module.exports = __webpack_public_path__ + "static/media/ready.acfc70fd.svg";